import {
  Checkbox,
  DatePicker,
  Form,
  Input,
  Modal,
  Select,
  Tag
} from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { rootContext } from 'stores';
import { getCreateUserTypes } from '../../common/utils';
import './Craeteuser.scss';
import dayjs from 'dayjs';

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 12 }
};
const Craeteuser: React.FC<{
  addUserModal: boolean;
  setAddUserModal: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ addUserModal, setAddUserModal }) => {
  const dateFormatList = ['DD/MM/YYYY', 'DD/MM/YY'];
  const [enableAllRegion, setEnableAllRegion] = useState(false);
  const [subscriptionEndDate, setSubscriptionEndDate] = useState<null | number>(null);
  const [subscriptionStartDate, setSubscriptionStartDate] = useState<null | number>(null);
  const [userType, setUserType] = useState('');

  const {
    RegionStore: {
      state: {
        data: { regions },
        ui: { getRegionsLoading }
      }
    },
    UsersRegions: {
      state: {
        data: { userRegions, getUserRegionsParams },
        ui: { isUserRegionsLoading }
      },
      getUserRegions
    },
    UsersStore: {
      state: { ui },
      addUser
    },
    AuthStore: {
      state: {
        data: { user }
      }
    }
  } = useContext(rootContext);
  const [createUserForm] = Form.useForm();

  useEffect(() => {
    getUserRegions({ ...getUserRegionsParams, limit: 9999999 });
  }, [getUserRegions, getUserRegionsParams]);

  function onChange(date: any, dateString: any) {
    setSubscriptionEndDate(date?.unix(dateString));
    console.log(date?.unix(dateString));
  }
  function onChangeStartDate(date: any, dateString: any) {
    setSubscriptionStartDate(date?.unix(dateString));
    console.log(date?.unix(dateString));
  }

  function disabledDate(current: any) {
    return current && current < dayjs().startOf('day');
  }
  return (
    <div className="CraeteuserStyles">
      <Modal
        visible={addUserModal}
        okText="Add"
        okButtonProps={{
          loading: ui.addUserLoading,
          onClick: () => createUserForm.submit()
        }}
        title="Create User"
        onCancel={() => {
          setEnableAllRegion(false);
          setAddUserModal(false);
          createUserForm.resetFields();
        }}
      >
        <Form
          {...layout}
          form={createUserForm}
          onFinish={async () => {
            const data = createUserForm.getFieldsValue();
            // return console.log(data);
            const success = await addUser({
              email: data.create_email,
              credit: data.credit,
              password: data.create_password,
              username: data.craete_username,
              userType: data.userType,
              region: data?.region ? data.region : null,
              country_of_origin_id: data?.countryOrigin
                ? data.countryOrigin
                : null,
              ...(subscriptionEndDate != null && { subscription_end_date: subscriptionEndDate * 1000 }),
              ...(subscriptionStartDate != null && { subscription_start_date: subscriptionStartDate * 1000 })
            });
            if (success) {
              createUserForm.resetFields();
              setAddUserModal(false);
            }
          }}
        >
          <Form.Item
            label="Email"
            name="create_email"
            rules={[
              { required: true, message: 'Please input email!' },
              { type: 'email', message: 'Invalid Email' }
            ]}
          >
            <Input name="create_email" placeholder="Email" autoComplete="off" />
          </Form.Item>
          <Form.Item
            label="User type"
            name="userType"
            rules={[{ required: true, message: 'Please input user type!' }]}
          >
            <Select
              placeholder="Select User Type"
              onChange={e => {
                setUserType(e);
              }}
              options={getCreateUserTypes(user?.userType).map(val => ({
                key: val,
                value: val,
                label: val[0].toUpperCase() + val.substring(1, val.length)
              }))}
            ></Select>
          </Form.Item>
          <Form.Item
            label="credit"
            key="credit"
            name="credit"
            rules={[{ required: true, message: 'Please input user credit!' }]}
          >
            <Input type="number" min="0" />
          </Form.Item>
          <Form.Item
            label="All Region"
            tooltip="All regions will be considered."
            name="all_region"
            rules={[
              {
                required: false,
                message: 'Please Enter Region'
              }
            ]}
          >
            <Checkbox
              value={enableAllRegion}
              style={{ marginLeft: '10px' }}
              onChange={e => setEnableAllRegion(e.target.checked)}
            ></Checkbox>
          </Form.Item>

          {!enableAllRegion && (
            <Form.Item
              label="Region"
              name="region"
              rules={[
                {
                  required: true,
                  message: 'Please Enter Region'
                }
              ]}
            >
              <Select
                tagRender={({ value }) => {
                  return <Tag>{regions.find(rg => rg.id === value)?.name}</Tag>;
                }}
                loading={getRegionsLoading}
                placeholder="Select Region"
                mode="multiple"
                showSearch={false}
                dropdownRender={menu => <div>{menu}</div>}
              >
                {regions?.map(({ name, id }) => (
                  <Select.Option key={id} value={id} className="regionOption">
                    <span>{name}</span>
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          )}
          <Form.Item
            label="Country Origin"
            name="countryOrigin"
            rules={[
              {
                required: true,
                message: 'Please Enter Country Origin'
              }
            ]}
          >
            <Select
              tagRender={({ value }) => {
                return (
                  <Tag>
                    {userRegions.find(rg => rg.id === value)?.country_name}
                  </Tag>
                );
              }}
              loading={isUserRegionsLoading}
              placeholder="Select Country Origin"
            >
              {userRegions?.map(({ country_name, id }) => (
                <Select.Option key={id} value={id} className="regionOption">
                  <span>{country_name}</span>
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          {userType === 'subscription' && (
            <>
              <Form.Item
                label="Subscription Start"
                name="subscriptionStartDate"
                rules={[
                  {
                    required: true,
                    message: 'Please Enter Subscription Start Date'
                  }
                ]}
              >
                <DatePicker
                  onChange={onChangeStartDate}
                  format={dateFormatList}
                  disabledDate={disabledDate}
                  placeholder="Subscription Start date"
                />
              </Form.Item>
              <Form.Item
                label="Subscription End"
                name="subscriptionEndDate"
                rules={[
                  {
                    required: true,
                    message: 'Please Enter Subscription End Date'
                  }
                ]}
              >
                <DatePicker
                  onChange={onChange}
                  format={dateFormatList}
                  disabledDate={disabledDate}
                  placeholder="Subscription End date"
                />
              </Form.Item>
            </>
          )}
        </Form>
      </Modal>
    </div>
  );
};

export default Craeteuser;
